// key 带 _v2 后缀：RBAC 改造后 admin 对象的结构变了（role 字段没了，
// 换成 resources/menus/companies）。旧 key 读不到 → 路由守卫自动跳登录页，
// 老用户重新登录一次即可，不需要写任何兼容代码，也不会因为缺字段白屏。
const TOKEN_KEY = 'oa_token_v2'
const ADMIN_KEY = 'oa_admin_v2'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(ADMIN_KEY)
  // 顺手清掉改造前的旧 key，避免 localStorage 里留一堆没人读的垃圾
  localStorage.removeItem('oa_token')
  localStorage.removeItem('oa_admin')
}

export function getAdmin() {
  const s = localStorage.getItem(ADMIN_KEY)
  if (!s) return null
  try {
    return JSON.parse(s)
  } catch (e) {
    return null
  }
}

export function setAdmin(admin) {
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin))
}

/** 当前账号是否拥有某个资源（超管隐式全有） */
export function hasResource(admin, code) {
  if (!admin) return false
  if (admin.is_super_admin) return true
  return Array.isArray(admin.resources) && admin.resources.includes(code)
}
